<template>
  <v-btn
    v-if="!modalEnabled"
    rounded
    :outlined="!mini"
    small
    :icon="mini"
    :color="'info'"
    title="Изменить адрес"
    @click="enableModal"
  >
    <v-icon>{{ 'mdi-pencil' }}</v-icon>
    <span
      v-if="!mini"
      class="ml-1"
    >{{ 'Изменить адрес' }}</span>
  </v-btn>
  <EditAddressForm
    v-else
    :model="model"
    :modal-enabled="modalEnabled"
    @EditAddressFormClosed="disableModal"
    @EditAddressFormSuccess="onSuccess"
  />
</template>
<script>

import EditAddressForm from '@/views/office/address/edit-address-form.vue'
export default {
  name: 'EditAddressFormDrawer',
  components: { EditAddressForm },
  props: {
    model: {
      type: Object,
    },
    mini: {
      type: Boolean,
    },
    confirmationEnabled: {
      type: Boolean,
    }
  },
  data () {
    return {
      modalEnabled: false,
    }
  },
  computed: {
  },
  watch: {
  },
  created () {
    console.log(this.model)
  },
  methods: {
    enableModal () {
      this.modalEnabled = true
    },
    onSuccess () {
      this.disableModal()
      this.$emit('EditAddressSuccess')
    },
    disableModal () {
      this.modalEnabled = false
    },
  }
}
</script>
